import React from 'react';
import Date from '../Date/Date';
import JobCard from '../JobCard/JobCard';

export default function JobCardWrapper({ days, handleShowJobDetails }) {
  const {
    date,
    jobs,
  } = days;

  const isJobInDate = !!jobs;

  const jobsInDate = jobs?.map((job, index) =>
    <JobCard
      key={index}
      job={job}
      handleShowJobDetails={handleShowJobDetails}
    />
  )

  return (
    <div className="mb-4">
      <Date date={date} isJobInDate={isJobInDate} />
      {jobsInDate}
    </div>
  )
}
